import { FC, useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getSkinId, setBodyOverflow } from 'src/helpers/utils';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { useI18n } from 'src/hooks/use-i18n-translation';
import useKycPopup from 'src/hooks/use-kycPopup';
import { gameUrlRequest } from 'src/services/gameApi';
import { setSelectedCategory } from 'src/store/app/actions';
import { openDialog } from 'src/store/dialog/actions';
import { RootState } from 'src/types/store-types';
import { EnumCmsWagerLangCodes, EnumLangCodes } from 'src/utils/constants';
import { printTicket } from './printTicket';

const Cms_Wager: FC<{ sportType: 'live' | 'sport' }> = ({ sportType }) => {
  const { locale } = useI18n();
  const skinId = getSkinId();
  const { user, kycStatus } = useSelector((state: RootState) => state.user);
  const { categoriesData } = useSelector((state: RootState) => state.configs);
  const { section } = useSelector((state: RootState) => state.accountModal);
  const _openDialog = useConnectedAction(openDialog);
  useKycPopup(kycStatus, user, section, _openDialog);
  const navigate = useNavigate();

  setBodyOverflow('unset');

  const _setSelectedCategory = useConnectedAction(setSelectedCategory);

  const [data, setData] = useState<any>(null);

  // Fetch game URL data.
  const getSportGame = async (): Promise<void> => {
    const game = categoriesData?.betting?.tags[0]?.tagGames[0];

    if (game) {
      const payload: any = {
        id: game.id,
        skinId,
        lang: locale,
        device: isMobile ? 'mobile' : 'desktop',
      };
      if (user) {
        payload.userId = user.id;
        payload.token = user.token;
      }
      const res: any = await gameUrlRequest(payload);
      if (res.result) {
        setData(res.result.data);
      } else {
        console.log(`get game url error ${game.id}`);
      }
    }
  };

  useEffect(() => {
    getSportGame();
  }, [user, categoriesData, skinId, locale]);

  useEffect(() => {
    if (typeof cmsSportbook !== 'undefined' && cmsSportbook && data) {
      const deviceType = isMobile ? 'mobile' : 'desktop';
      const userStatus = user ? data.token : 'guest';
      cmsSportbook?.startSportbook(
        deviceType,
        userStatus,
        EnumCmsWagerLangCodes[locale] || EnumLangCodes[locale],
        data?.clientKey,
        sportType
      );
    } else {
      console.warn('cmsSportbook not available');
    }
  }, [user, locale, data, sportType]);
  console.log('🚀 ~ data:', data);

  useEffect(() => {
    const handleMessage = (event: MessageEvent): void => {
      const { data } = event;
      if (!data) return;

      if (data.action === 'redirectTo') {
        setTimeout(() => {
          setBodyOverflow('set');
        }, 500);

        switch (data.category) {
          case 'casino':
            _setSelectedCategory('casino');
            navigate('/category/casino');
            break;
          case 'livecasino':
            _setSelectedCategory('liveCasino');
            navigate('/category/liveCasino');
            break;
          default:
            _setSelectedCategory('home');
            navigate('/');
        }
      }

      // Handle print-ticket
      if (data.action === 'printTicket' && data?.jsonData) {
        const ticket = JSON.parse(data.jsonData);
        printTicket(ticket);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return <div id="appcontent"></div>;
};

export default Cms_Wager;
